import React from "react";

const Disclaimer = ({ compact = false }) => (
  <div
    data-testid="legal-disclaimer"
    className={`border border-[#22222B] bg-[#12121A] ${compact ? "p-4" : "p-6"} text-xs leading-relaxed text-[#8F8F99]`}
  >
    <div className="flex items-start gap-3">
      <span className="mt-0.5 text-[#00DF82] uppercase tracking-widest text-[10px] font-medium shrink-0">Aviso</span>
      <p className="text-balance">
        Vendemos únicamente el producto. Podemos orientarte por WhatsApp con información general de uso — sin reemplazar criterio médico o profesional.
      </p>
    </div>
  </div>
);

export default Disclaimer;
